import firebase from 'firebase/compat/app';

import STORE_CONSTANTS from './constants';

const converter = {
  toFirestore(item: InsightsQueryLog.Doc): firebase.firestore.DocumentData {
    return { ...item };
  },
  fromFirestore(
    snapshot: firebase.firestore.QueryDocumentSnapshot,
    options: firebase.firestore.SnapshotOptions,
  ): InsightsQueryLog.Doc {
    return {
      ...(snapshot.data(options) as InsightsQueryLog.Doc),
      id: snapshot.id,
    };
  },
};

// Insights query log: accounts/{accountId}/insightsQueryLog/{id}. Staff-read
// (see firestore.rules); Admin-SDK write only, so read-only in the client (used
// by the quality dashboard).
const getInsightsQueryLogRef = ({
  accountId,
  db,
}: {
  accountId: string;
  db?: firebase.firestore.Firestore;
}) => {
  return (db ? db : firebase.firestore())
    .collection('accounts')
    .doc(accountId)
    .collection(STORE_CONSTANTS.INSIGHTS_QUERY_LOG_COLLECTION)
    .withConverter(converter);
};

export default getInsightsQueryLogRef;
